<template>
  <div
    id="kt_modal_agencia_boleto_licenca_editar"
    ref="kt_modal_agencia_boleto_licenca_editar"
    data-bs-backdrop="static"
    class="modal fade modal-overlay"
    tabindex="-1"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header p-3 bg-light">
          <h4 class="modal-title" v-if="this.id === 0">
            <img
              src="media/icons/duotune/general/gen055.svg"
              class="me-2"
            />Adicionar Agência
          </h4>
          <h4 class="modal-title" v-else>
            <img
              src="media/icons/duotune/general/gen055.svg"
              class="me-2"
            />Editar Agência
          </h4>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1 svg-icon lh-0">
              <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-8">
          <div class="row">
            <div
              v-if="this.errosGerais && this.errosGerais.Message"
              class="notice d-flex bg-light-danger rounded border-danger border border-dashed mb-9 p-6"
            >
              <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
                <inline-svg src="media/icons/duotune/general/gen044.svg" />
              </span>
              <div class="d-flex flex-stack flex-grow-1">
                <div class="fw-bold">
                  <h4 class="text-gray-800 fw-bolder">Aviso</h4>
                  <div class="fs-6 text-gray-600">
                    {{ this.errosGerais.Message }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-8 col-xl-4 col-xxl-4 fv-row mb-2"
            >
              <label class="required form-label">Conta</label>
              <input
                :id="`txtConta`"
                type="text"
                class="form-control mb-2"
                placeholder="Conta"
                maxlength="255"
                v-model="this.agenciaBoletoLicenca.conta"
              />
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["conta"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-4 col-xl-2 col-xxl-2 fv-row mb-2"
            >
              <label class="form-label">Dígito Conta</label>
              <input
                :id="`txtDVConta`"
                type="text"
                class="form-control mb-2"
                placeholder="DV"
                maxlength="1"
                v-model="this.agenciaBoletoLicenca.dv_conta"
              />
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["dv_conta"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6 fv-row mb-2"
            >
              <label class="required form-label">Banco</label>
              <select
                class="form-select"
                aria-label="banco"
                v-model="this.agenciaBoletoLicenca.banco"
              >
                <option value="756">
                  756 - Banco Cooperativo do Brasil S.A. – BANCOOB
                </option>
              </select>
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["banco"] }}
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-8 col-xl-4 col-xxl-4 fv-row mb-2"
            >
              <label class="required form-label">Agência</label>
              <input
                :id="`txtAgencia`"
                type="text"
                class="form-control mb-2"
                placeholder="Agência"
                maxlength="255"
                v-model="this.agenciaBoletoLicenca.agencia"
              />
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["agencia"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-4 col-xl-2 col-xxl-2 fv-row mb-2"
            >
              <label class="form-label">Dígito Agência</label>
              <input
                :id="`txtDVAgencia`"
                type="text"
                class="form-control mb-2"
                placeholder="DV Agência"
                maxlength="1"
                v-model="this.agenciaBoletoLicenca.dv_agencia"
              />
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["dv_agencia"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-8 col-xl-4 col-xxl-4 fv-row mb-2"
            >
              <label class="required form-label">Código Cedente</label>
              <input
                :id="`txtCodigoCedente`"
                type="text"
                class="form-control mb-2"
                placeholder="Código Cedente"
                maxlength="255"
                v-model="this.agenciaBoletoLicenca.codigo_cedente"
              />
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["codigo_cedente"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-4 col-xl-2 col-xxl-2 fv-row mb-2"
            >
              <label class="form-label">Dígito Cedente</label>
              <input
                :id="`txtDVCedente`"
                type="text"
                class="form-control mb-2"
                placeholder="DV Cedente"
                maxlength="1"
                v-model="this.agenciaBoletoLicenca.dv_cedente"
              />
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["dv_cedente"] }}
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-4 col-xl-2 col-xxl-2 fv-row mb-2"
            >
              <label class="required form-label">Carteira</label>
              <input
                :id="`txtCarteira`"
                type="text"
                class="form-control mb-2"
                placeholder="Carteira"
                maxlength="255"
                v-model="this.agenciaBoletoLicenca.carteira"
              />
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["carteira"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-4 col-xl-2 col-xxl-2 fv-row mb-2"
            >
              <label class="required form-label">Variação</label>
              <input
                :id="`txtVariacao`"
                type="text"
                class="form-control mb-2"
                placeholder="Variação"
                maxlength="255"
                v-model="this.agenciaBoletoLicenca.variacao"
              />
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["variacao"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-4 col-xl-2 col-xxl-2 fv-row mb-2"
            >
              <label class="required form-label">Modalidade</label>
              <input
                :id="`txtModalidade`"
                type="text"
                class="form-control mb-2"
                placeholder="Modalidade"
                maxlength="255"
                v-model="this.agenciaBoletoLicenca.modalidade"
              />
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["modalidade"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-4 col-xl-2 col-xxl-2 fv-row mb-2"
            >
              <label class="required form-label">Seq. Remessa</label>
              <input
                :id="`txtSeqRemessa`"
                type="text"
                class="form-control mb-2"
                placeholder="Seq. Remessa"
                maxlength="255"
                v-model="this.agenciaBoletoLicenca.seq_remessa"
              />
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["seq_remessa"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-4 col-xl-4 col-xxl-4 fv-row mb-2"
            >
              <label class="required form-label">Cód Convênio</label>
              <input
                :id="`txtCodConvenio`"
                type="text"
                class="form-control mb-2"
                placeholder="Cód. Convênio"
                maxlength="255"
                v-model="this.agenciaBoletoLicenca.cod_convenio"
              />
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["cod_convenio"] }}
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-4 col-xl-4 col-xxl-4 fv-row mb-2"
            >
              <label class="required form-label">Nosso Número</label>
              <input
                :id="`txtNossoNumero`"
                type="text"
                class="form-control mb-2"
                placeholder="Nosso Número"
                maxlength="15"
                v-model="this.agenciaBoletoLicenca.nosso_numero"
              />
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["nosso_numero"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-4 col-xl-3 col-xxl-3 fv-row mb-2"
            >
              <label class="required form-label">Tipo Arquivo</label>
              <select
                class="form-select"
                aria-label="Tipo arquivo"
                v-model="this.agenciaBoletoLicenca.tipo_layout"
              >
                <option value="240">CNAB 240</option>
                <option value="400">CNAB 400</option>
              </select>
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["tipo_layout"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-4 col-xl-3 col-xxl-3 fv-row mb-2"
            >
              <label class="required form-label">Layout arquivo</label>
              <input
                :id="`txtLayoutArquivo`"
                type="text"
                class="form-control mb-2"
                placeholder="Layout arquivo"
                maxlength="255"
                v-model="this.agenciaBoletoLicenca.layout_arquivo"
              />
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["layout_arquivo"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-4 col-xl-2 col-xxl-2 fv-row mb-2"
            >
              <label class="required form-label">Versão arquivo</label>
              <input
                :id="`txtVersãoArquivo`"
                type="text"
                class="form-control mb-2"
                placeholder="Versão arquivo"
                maxlength="255"
                v-model="this.agenciaBoletoLicenca.versao_arquivo"
              />
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["versao_arquivo"] }}
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-4 col-xl-3 col-xxl-3 fv-row mb-2"
            >
              <label class="required form-label">Nº Dias Juros Mora</label>
              <input
                :id="`txtDiasJurosMora`"
                type="text"
                class="form-control mb-2"
                placeholder="Dias Juros Mora"
                maxlength="10"
                v-model="this.agenciaBoletoLicenca.num_dias_mora"
              />
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["num_dias_mora"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-4 col-xl-3 col-xxl-3 fv-row mb-2"
            >
              <label class="required form-label">% Juros Mora</label>
              <CurrencyInput
                class="form-control mb-2"
                placeholder="% Juros Mora"
                style="text-align: right"
                v-model="this.agenciaBoletoLicenca.per_mora_diaria"
                :options="options"
              ></CurrencyInput>
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["per_mora_diaria"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-4 col-xl-3 col-xxl-3 fv-row mb-2"
            >
              <label class="required form-label">Nº Dias Protesto</label>
              <input
                :id="`txtDiasProtesto`"
                type="text"
                class="form-control mb-2"
                placeholder="Dias Protesto"
                maxlength="10"
                v-model="this.agenciaBoletoLicenca.num_dias_protesto"
              />
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["num_dias_protesto"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-4 col-xl-3 col-xxl-3 fv-row mb-2"
            >
              <label class="required form-label">% Multa Atraso</label>
              <CurrencyInput
                class="form-control mb-2"
                placeholder="% Multa Atraso"
                style="text-align: right"
                v-model="this.agenciaBoletoLicenca.per_multa_atraso"
                :options="options"
              ></CurrencyInput>
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["per_multa_atraso"] }}
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-6 col-xl-2 col-xxl-2 fv-row mb-2"
            >
              <label class="required form-label">Aceite</label>
              <select
                class="form-select"
                aria-label="banco"
                v-model="this.agenciaBoletoLicenca.aceite_documento"
              >
                <option value="1">Sim</option>
                <option value="0">Não</option>
              </select>
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["aceite_documento"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-4 col-xl-3 col-xxl-3 fv-row mb-2"
            >
              <label class="required form-label">Nº Dias Desconto</label>
              <input
                :id="`txtDiasDesconto`"
                type="text"
                class="form-control mb-2"
                placeholder="Dias Protesto"
                maxlength="10"
                v-model="this.agenciaBoletoLicenca.dias_desconto"
              />
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["dias_desconto"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-4 col-xl-3 col-xxl-3 fv-row mb-2"
            >
              <label class="required form-label">% Desconto</label>
              <CurrencyInput
                class="form-control mb-2"
                placeholder="% Desconto"
                style="text-align: right"
                v-model="this.agenciaBoletoLicenca.percentual_desconto"
                :options="options"
              ></CurrencyInput>
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["percentual_desconto"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-6 col-xl-4 col-xxl-4 fv-row mb-2"
            >
              <label class="required form-label">Tipo Juros</label>
              <select
                class="form-select"
                aria-label="Tipo Juros"
                v-model="this.agenciaBoletoLicenca.tipo_juros_boleto"
              >
                <option value="1">Valor por dia</option>
                <option value="2">Taxa Mensal</option>
                <option value="3">Isento</option>
              </select>
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["tipo_juros_boleto"] }}
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-2"
            >
              <label class="form-label">Instrução 1</label>
              <input
                :id="`txtInstrucao1`"
                type="text"
                class="form-control mb-2"
                placeholder="Instrução 1"
                maxlength="255"
                v-model="this.agenciaBoletoLicenca.instrucao_1"
              />
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["instrucao_1"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-2"
            >
              <label class="form-label">Instrução 2</label>
              <input
                :id="`txtInstrucao2`"
                type="text"
                class="form-control mb-2"
                placeholder="Instrução 2"
                maxlength="255"
                v-model="this.agenciaBoletoLicenca.instrucao_2"
              />
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["instrucao_2"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-2"
            >
              <label class="form-label">Instrução 3</label>
              <input
                :id="`txtInstrucao3`"
                type="text"
                class="form-control mb-2"
                placeholder="Instrução 3"
                maxlength="255"
                v-model="this.agenciaBoletoLicenca.instrucao_3"
              />
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["instrucao_3"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-2"
            >
              <label class="form-label">Instrução 4</label>
              <input
                :id="`txtInstrucao4`"
                type="text"
                class="form-control mb-2"
                placeholder="Instrução 4"
                maxlength="255"
                v-model="this.agenciaBoletoLicenca.instrucao_4"
              />
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["instrucao_4"] }}
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <button
            class="btn btn-danger svg-icon-white me-2 mb-2"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-2"
              />Cancelar
            </span>
          </button>
          <button
            class="btn btn-success svg-icon-white mb-2"
            :id="`btnConfirmar`"
            @click="confirmar()"
            v-bind:data-kt-indicator="this.loading ? 'on' : 'off'"
          >
            <span class="indicator-progress">
              <span
                class="spinner-border spinner-border-sm align-middle ms-1"
              ></span>
              Aguarde...
            </span>
            <span class="svg-icon svg-icon-1" v-if="!this.loading">
              <inline-svg
                src="media/icons/duotune/arrows/arr016.svg"
                class="me-2"
              />Confirmar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";
import {
  hideModal,
  getOrCreateInstanceModal,
  hideModalId,
} from "@/core/helpers/dom";
const toast = useToast();
import CurrencyInput from "@/components/text/CurrencyInput";
import Swal from "sweetalert2/dist/sweetalert2.min.js";

const agenciaBoletoLicencaInicializado = {
  id: 0,
  conta: "",
  dv_conta: "",
  banco: "",
  agencia: "",
  dv_agencia: "",
  nome_banco: "",
  codigo_cedente: "",
  dv_cedente: "",
  carteira: "",
  variacao: "",
  nosso_numero: 0,
  tipo_layout: "240",
  per_mora_diaria: 0,
  num_dias_mora: 0,
  per_multa_atraso: 0,
  num_dias_atraso: 0,
  aceite_documento: "1",
  instrucao_1: "",
  instrucao_2: "",
  instrucao_3: "",
  instrucao_4: "",
  seq_remessa: 0,
  cod_convenio: "",
  modalidade: "",
  tipo_juros_boleto: "2",
  layout_arquivo: "",
  versao_arquivo: "",
  dias_desconto: 0,
  percentual_desconto: 0,
};

export default {
  emits: [
    "exibirEditarAgenciaBoletoLicencaModal",
    "confirmarEditarAgenciaBoletoLicencaModal",
  ],
  components: {
    CurrencyInput,
  },
  props: {
    id: { type: Number, required: true },
  },
  methods: {
    async confirmar() {
      this.errosValidacao = [];
      this.loading = true;
      if ((await this.validar()) === true) {
        if (this.agenciaBoletoLicenca.banco === "756") {
          this.agenciaBoletoLicenca.nome_banco =
            "Banco Cooperativo do Brasil S.A. – BANCOOB";
        }

        if (this.id <= 0) {
          try {
            let formData = this.$utils.convertModelToFormData(
              this.agenciaBoletoLicenca
            );
            var ret = await this.$store.dispatch(
              "agenciaBoletoLicenca/postAgenciaBoletoLicenca",
              formData
            );
            if (ret.Success === true) {
              toast.success("Agência adicionada com sucesso!", {
                timeout: 3000,
              });
              this.$emit("confirmarEditarAgenciaBoletoLicencaModal", false);
              hideModal(this.$refs.kt_modal_agencia_boleto_licenca_editar);
            }
          } catch (error) {
            this.errosValidacao = error;
          }
        } else {
          try {
            let formData = this.$utils.convertModelToFormData(
              this.agenciaBoletoLicenca
            );
            let retPut = await this.$store.dispatch(
              "agenciaBoletoLicenca/putAgenciaBoletoLicenca",
              formData
            );
            if (retPut.Success === true) {
              toast.success("Agência atualizada com sucesso!", {
                timeout: 3000,
              });
              this.$emit("confirmarEditarAgenciaBoletoLicencaModal", false);
              hideModal(this.$refs.kt_modal_agencia_boleto_licenca_editar);
            }
          } catch (error) {
            this.errosValidacao = error;
          }
        }
      } else {
        await Swal.fire({
          text: "Verifique os avisos antes de prosseguir!",
          icon: "warning",
          buttonsStyling: false,
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn fw-bold btn-warning",
          },
        });
      }
      this.loading = false;
    },
    async validar() {
      this.errosGerais = [];
      return true;
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    cancelar() {
      hideModal(this.$refs.kt_modal_agencia_boleto_licenca_editar);
      this.$emit("exibirEditarAgenciaBoletoLicencaModal", false);
    },
  },
  async mounted() {
    this.loading = true;
    this.errosValidacao = [];
    this.errosGerais = [];

    if (this.id <= 0) {
      this.agenciaBoletoLicenca = JSON.parse(
        JSON.stringify(agenciaBoletoLicencaInicializado)
      );
    } else {
      try {
        let ret = await this.$store.dispatch(
          "agenciaBoletoLicenca/getAgenciaBoletoLicenca",
          this.id
        );

        if (ret.Success === true) {
          this.agenciaBoletoLicenca = ret.Data;
        }
      } catch (error) {
        console.log(error);
      }
    }

    this.loading = false;
    setTimeout(() => {
      this.nextFocus(`txtConta`);
    }, 800);
  },
  data() {
    return {
      errosGerais: [],
      errosValidacao: [],
      agenciaBoletoLicenca: JSON.parse(
        JSON.stringify(agenciaBoletoLicencaInicializado)
      ),
      loading: false,
      options: {
        locale: "pt-BR",
        currency: "BRL",
        currencyDisplay: "hidden",
        precision: 2,
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: true,
        autoSign: true,
        useGrouping: true,
        accountingSign: true,
      },
    };
  },
};
</script>

<style></style>
